import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackCreatedCdnLink.meta';

export type TrackCreatedCdnLinkParams = {
  action: 'create' | 'reactivate';
  asset_id: string;
};

export const useTrackCreatedCdnLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreatedCdnLink = useCallback(
    (params: TrackCreatedCdnLinkParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreatedCdnLink };
};
